import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

export function getBonusesConfig() {
    return {
        palette: {
            [PALETTE_IDS.BONUSES]: {
                PROMOTION_CODE_INPUT: {
                    INPUT_LABEL_TEXT: COLOR.BRAND.FOREGROUND2,
                },
                BONUSES_SECTION_TITLE_TEXT: {
                    fontSize: FONT.SIZE_LARGE,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                    color: COLOR.BRAND.FOREGROUND1,
                    fontFamily: FONT.FAMILY_SECOND,
                },
                BONUS_ITEM_TITLE_TEXT: {
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                    color: COLOR.BRAND.FOREGROUND1,
                    textTransform: 'uppercase',
                },
                BONUS_ITEM_STATUS_TEXT: {
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                    color: COLOR.BRAND.FOREGROUND1,
                },
                BONUS_ITEM_EXPIRY_DATE_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontStyle: 'italic',
                },
                BONUS_ITEM_DESCRIPTION_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontStyle: 'italic',
                },
                BONUS_ITEM_PROGRESS_BAR: {
                    PROGRESS_BAR_RANGE_LABEL_TEXT: {
                        color: COLOR.BRAND.FOREGROUND1,
                        fontStyle: 'italic',
                    },
                    PROGRESS_BAR_LIMIT_LABEL_TEXT: {
                        color: COLOR.BRAND.FOREGROUND1,
                        fontStyle: 'italic',
                    },
                },
                BONUS_ITEM_STEP_TITLE_TEXT: {
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                    color: COLOR.BRAND.FOREGROUND1,
                },
                BONUS_ITEM_STEP_STATUS_TEXT: {
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                    color: COLOR.BRAND.FOREGROUND1,
                },
                BONUS_ITEM_STEP_DESCRIPTION_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontStyle: 'italic',
                },

                BONUS_ITEM_AMOUNT_TEXT: 'transparent', // DBX-14401 Hide bonus amount
            },
        },
    };
}
